import React from "react";
import { NodeViewWrapper, NodeViewContent } from "@tiptap/react";

const TableBlockComponent = ({ node, editor, getPos }) => {
    const deleteTable = () => {
        const pos = getPos();
        editor
            .chain()
            .focus()
            .deleteRange({
                from: pos,
                to: pos + node.nodeSize,
            })
            .run();
    };

    return (
        <NodeViewWrapper className="table-block-wrapper">
            <div className="table-block-header">
                <div className="table-header-left">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', opacity: 0.5 }}>
                        <path d="M3 3h18v18H3zM3 9h18M9 3v18" />
                    </svg>
                    <span className="table-label">Table Component</span>
                </div>
                <button className="delete-table-btn" onClick={deleteTable} title="Delete Table">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                </button>
            </div>
            <div className="table-block-content">
                <NodeViewContent as="table" className="custom-table" />
            </div>
        </NodeViewWrapper>
    );
};

export default TableBlockComponent;
